import { Controller } from '@hotwired/stimulus'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ['element']

  static values = {
    intensity: { type: Number, default: 1 },
  }

  connect() {
    this.triggers = []
    this.elementTargets.forEach((element, index) => {
      this.createScrollAnimation(element, index)
    })
  }

  disconnect() {
    this.triggers.forEach((trigger) => trigger.kill())
    this.triggers = []
  }

  createScrollAnimation(element, index) {
    const config = this.constructor.getScrollConfig(index)
    const intensity = this.intensityValue

    const trigger = ScrollTrigger.create({
      trigger: this.element,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
      animation: gsap.to(element, {
        y: () => window.innerHeight * config.speed * 0.6 * intensity,
        x: config.horizontalDrift * intensity,
        ease: 'none',
      }),
    })

    this.triggers.push(trigger)
  }

  static getScrollConfig(index) {
    const speed = 0.3 + (index * 0.1)
    const horizontalDrift = (Math.random() - 0.5) * 60

    return { speed, horizontalDrift }
  }
}
